import MyEvaluationsView from "../../features/performance/MyEvaluationsView";

const MyEvaluationsPage = () => <MyEvaluationsView />;

export default MyEvaluationsPage;
